'use client'

import { Suspense, useEffect, useState } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import Link from 'next/link'
import styles from '../PreviewBadge/PreviewBadge.module.css'

type PreviewBadgeClientProps = {
  label?: string
}

function PreviewBadgeInner({
  label = 'Preview mode activated, click to disable',
}: PreviewBadgeClientProps) {
  const [isPreview, setIsPreview] = useState(false)
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    setIsPreview(document.cookie.includes('__preview_mode'))
  }, [searchParams])

  if (!isPreview) return null

  const slug = pathname === '/' ? '' : pathname.replace(/^\//, '')

  return (
    <div className={styles.badge}>
      <span
        aria-hidden
        className={styles.dot}
      />

      <Link
        href={`/api/preview/disable${slug ? `?slug=${encodeURIComponent(slug)}` : ''}`}
        prefetch={false}
        className={styles.label}
      >
        {label}
      </Link>
    </div>
  )
}

export default function PreviewBadgeClient(props: PreviewBadgeClientProps) {
  return (
    <Suspense fallback={null}>
      <PreviewBadgeInner {...props} />
    </Suspense>
  )
}
